import { render, staticRenderFns } from "./CustomerCrmCampaignList.vue?vue&type=template&id=7f8c65d1&"
import script from "./CustomerCrmCampaignList.vue?vue&type=script&lang=js&"
export * from "./CustomerCrmCampaignList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports